module.exports = __webpack_public_path__ + "static/img/12.5f61213.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/5/zh/12.png
// module id = 7Uc2
// module chunks = 0